import { useTranslation } from 'react-i18next';
import { PaperClipIcon } from '@heroicons/react/24/outline';

import { ButtonType } from 'components/Form/Button/Button';
import { FileRow } from 'components/Form/FileRow/FileRow';

type ExternalFile = {
  url: string;
  filename?: string;
};

type ExternalFileAction = Partial<Pick<ButtonType, 'LeftIcon' | 'RightIcon' | 'analyticsId'>> & {
  label: string;
  onClick: (file: ExternalFile) => void;
};

type ExternalFilesListProps = {
  externalFiles: Array<ExternalFile>;
  action: ExternalFileAction;
};

export const ExternalFilesList = ({ externalFiles, action }: ExternalFilesListProps) => {
  const { t } = useTranslation();

  if (externalFiles?.filter((value) => value.url)?.length === 0) {
    return null;
  }

  return (
    <>
      {externalFiles.map((file, index) => (
        <FileRow
          key={index}
          icon={PaperClipIcon}
          text={file.filename || t('common:form.externalAction.attachmentIncluded')}
          action={{
            ...action,
            onClick: () => action.onClick(file),
          }}
        />
      ))}
    </>
  );
};
